<template>
    <div class="inputWrap" :class="{ 'hasError': v.$error }">
        <label v-if="label" :for="id">{{ label }}</label>
        <div class="inputInnerWrap">
            <input
                :type="type || 'text'"
                :id="id"
                :value="value"
                :maxlength="maxlength"
                :placeholder="placeholder"
                v-on:input="$emit('input', $event.target.value)"
                :disabled="hasEdit"
                ref="id"
            >
            <span v-if="edit" @click="toggleEdit" class="edit"><span v-if="hasEdit">{{'components/form/input.edit' | trans}}</span><span v-if="!hasEdit">{{'components/form/input.ok' | trans}}</span></span>
        </div>
        <div class="error" v-if="v.$error">
            <div v-if="!v.required">{{ requiredMessage || 'components/form/input.field-is-required' | trans }}</div>
            <div v-if="v.numeric == false ">{{ numericMessage || 'components/form/input.should-only-contain-numbers' | trans }}</div>
			<div v-if="v.minLength == false">{{minLengthMessage || 'components/form/input.field-must-have-at-least-characters' | trans({count: v.$params.minLength.min}) }}</div>
            <div v-if="!v.maxLengthMessage">{{ maxLengthMessage }}</div>
            <div v-if="!v.numbersAndSpaces">{{ numbersAndSpacesMessage }}</div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                hasEdit: this.edit,
            }
        },
        mounted() {
            //console.log(this.edit);
        },
        methods: {
            toggleEdit: function() {
                this.hasEdit = !this.hasEdit;
                this.$nextTick(() => {
                    this.$refs.id.focus();
                })
            }
        },
        props: {
            value: {
              type: String
            },
            label: {
                type: String
            },
            id: {
                type: String
            },
            type: {
                type: String
            },
            placeholder: {
                type: String
            },
            edit: {
                type: Boolean
            },
            maxlength: {
                type: String
            },
            v: {
              type: Object,
                default: () => ({
                    $error: false
                })
            },
            requiredMessage: {
                type: String
            },
            numericMessage: {
                type: String
            },
            minLengthMessage: {
                type: String
            },
            maxLengthMessage: {
                type: String
            },
            numbersAndSpacesMessage: {
                type: String
            }
        },
    }
</script>
